import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'WorkReport',
    column_type: 'id',
  },
  created_at: {
    model_name: 'WorkReport',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'WorkReport',
    column_type: 'datetime',
  },
  user: {
    model_name: 'WorkReport',
    column_type: 'belongs_to',
    extra: {
      association_name: 'user',
      model_name: 'User',
    },
  },
  user_id: {
    model_name: 'WorkReport',
    column_type: 'belongs_to',
    extra: {
      association_name: 'user',
      model_name: 'User',
    },
  },
  date: {
    model_name: 'WorkReport',
    column_type: 'date',
  },
  content: {
    model_name: 'WorkReport',
    column_type: 'text',
  },
  plan: {
    model_name: 'WorkReport',
    column_type: 'text',
  },
  inquiry_content: {
    model_name: 'WorkReport',
    column_type: 'text',
  },
  files: {
    model_name: 'WorkReport',
    column_type: 'attached',
    extra: {
      limit: 9,
      size: 5,
    },
  },
  can_update: {
    model_name: 'WorkReport',
    column_type: 'string',
  },
  can_destroy: {
    model_name: 'WorkReport',
    column_type: 'string',
  },
  follow_records: {
    model_name: 'WorkReport',
    column_type: 'string',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
